import { Component, OnChanges, Input,SimpleChanges, Output,
  EventEmitter, AfterViewInit, ViewChild } from '@angular/core';
import { Account } from '@app/models/account';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import { LoansService } from '@app/services/loan.service';
import { environment } from '@environments/environment';

@Component({
    selector: 'mrp-account-tree',
    templateUrl: './mrp-account-tree.component.html',
    styleUrls: ['./mrp-account-tree.component.scss'],
    standalone: false
})
export class MrpAccountTreeComponent implements OnChanges {
  // Datos de cuentas
  @Input() accountData: Account[] = [];
  // Seleccion de cuentas
  @Output() accountSelected = new EventEmitter<any>();
  // Configuracion para cmoponente de MatTree
  dataSource = new MatTreeNestedDataSource<Account>();
  treeControl = new NestedTreeControl<Account>(node => node.child);
  // Usuario autenticado
  currentUser: any;
  // Nodo seleccionado del componente
  nodeSelected: any;
  optionSelected: string = "Ver contratos";

  constructor(
    private loansService: LoansService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
   }

   // Valida si hay nodos hijos
  hasChild = (_: number, node: Account) => !!node.child && node.child.length > 0;

  ngOnChanges() {
    this.dataSource.data = this.accountData;
  }

  onAccountSelected(account_id: number, is_for_all_loans?:boolean) {
    is_for_all_loans = is_for_all_loans != null ? is_for_all_loans : false;
    account_id = account_id != null ? account_id : this.currentUser.mr_user_id;
    this.optionSelected = is_for_all_loans ? "Todas las cuentas" : "Cuenta actual";

    if (is_for_all_loans) {
      let accounts_selected = this.getMrpIds(this.nodeSelected);
      this.accountSelected.emit(accounts_selected);
    } else {
      this.accountSelected.emit(account_id);
    }
  }

  selectNode(node) {
    this.optionSelected = "Ver contratos";
    if (this.nodeSelected != null && this.nodeSelected.id == node.id) {
      node.active = false;
      this.nodeSelected = null;
    } else {
      if (this.nodeSelected != null) {
        this.nodeSelected.active = false;
      }
      this.nodeSelected = node;
      node.active = true;
    }
  }

  getMrpIds(data?:any,iterative?:number[]) {
    iterative = iterative != null ? iterative : [];

    // Asigna el id del padre
    if (!Array.isArray(data)) {
      iterative.push(data.id);
      this.getMrpIds(data.child, iterative);
    }

    for (let i = 0; i < data.length; i++ ) {
        let account = data[i];
        iterative.push(account.id);
        if (account.child.length > 0 ) {
          this.getMrpIds(account.child, iterative);
        }
    }

    return iterative;
  }

}
